import { useState } from 'react'

export function useMultiSelect () {
  const [selectedIds, setSelectedIds] = useState<Array<string>>([])

  const toggleSelect = (id: string) => {
    if (selectedIds.includes(id)) {
      setSelectedIds(selectedIds.filter(i => i !== id))
    } else {
      setSelectedIds([...selectedIds, id])
    }
  }

  const toggleSelectAll = (allItems: Array<{ id: string }>) => {
    if (selectedIds.length === allItems.length) {
      setSelectedIds([])
    } else {
      setSelectedIds(allItems.map(i => i.id))
    }
  }

  return { selectedIds, setSelectedIds, toggleSelect, toggleSelectAll }
}
